import { useCookies } from 'react-cookie'

import { canaryCookieKey } from 'pages/_document'

import { useEffect } from 'react'

export const useCanary = () => {
  const [{ [canaryCookieKey]: canaryEnabled }] = useCookies([canaryCookieKey])

  return canaryEnabled === '1'
}

const oneYear = new Date(Date.now() + 1000 * 60 * 60 * 24 * 365)

/**
 * Used to randomly enable
 *
 * @param key - Key of the cookie
 * @param rollChance - value between 0 and 1, used to when rolling to see whether or not the user will have this enabled
 * @param expiration -
 *
 * @returns boolean - Whether or not the trail is enabled
 */
export const useRandomCanryTrial = (
  key: string,
  rollChance: number,
  expires: Date,
): [boolean, (dismissExpiration?: Date) => void] => {
  const [{ [key]: cachedValue }, setCookies] = useCookies([key])

  const isEnabled = cachedValue === '1' || cachedValue === 'true' || cachedValue === 'TRUE'

  const handleRejectCanary = (dismissExpiration: Date = oneYear) => {
    setCookies(key, false, { path: '/', expires: dismissExpiration })
  }

  useEffect(() => {
    if (cachedValue !== undefined) return

    const enableTrial = rollChance >= Math.random()

    setCookies(key, enableTrial, { path: '/', expires })
  }, [])

  return [isEnabled, handleRejectCanary]
}

/**
 * Return a number from 0 to rollBreakpoints.length - 1 randomly with the frequency of the rolls being deteremed by the breakpoints provided
 *
 * @param key - Cookie key
 * @param rollBreakpoints - eg: [.33, .66, 1]
 * @param expires - Date to re-roll
 *
 * @returns
 */
export const useRandomType = (key: string, rollBreakpoints: number[], expires: Date): number => {
  const [{ [key]: cachedValue }, setCookies] = useCookies([key])

  const handleSetRandomType = (type: number) => setCookies(key, type, { path: '/', expires })

  useEffect(() => {
    if (cachedValue !== undefined) return

    const random = Math.random()

    for (let i = 0; i < rollBreakpoints.length - 1; i++) {
      const breakpoint = rollBreakpoints[i]

      if (random <= breakpoint) return handleSetRandomType(i)
    }

    handleSetRandomType(rollBreakpoints.length - 1)
  }, [])

  const type: number = cachedValue !== undefined ? Number(cachedValue) || 0 : 0

  return type
}
